import Api from '../api';
import { t } from 'i18next';
import Cookies from 'js-cookie';

export default class BusinessProfileApi extends Api {
  updateBusinessProfileDetails = async payload => {
    try {
      const apiData = await this.put(`linkedAccount`, payload);
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error.response,
        customMessage: t('GRAAS_FAIL_TO_UPDATE_PROFILE_GRAAS')
      };
    }
  };
  getLinkedProfileList = async props => {
    try {
      const { data } = await this.get(`accounts/profile`);
      return { data };
    } catch (error) {
      return {
        hasError: true,
        error: error.response
      };
    }
  };
  getLinkedAddressList = async props => {
    try {
      const { data } = await this.get(`linkedAccountDetails?type=address`);
      return { data };
    } catch (error) {
      return {
        hasError: true,
        error: error.response
      };
    }
  };

  onCreateUser = async payload => {
    try {
      const { data } = await this.post('/users', payload);
      return { data };
    } catch (error) {
      return {
        hasError: true,
        error: error.response
      };
    }
  };

  onUpdateUser = async payload => {
    try {
      const { data } = await this.put('/users', payload);
      return { data };
    } catch (error) {
      return {
        hasError: true,
        error: error.response
      };
    }
  };

  onDeleteUser = async payload => {
    try {
      const { data } = await this.delete(`/users?userID=${payload}`);
      return { data };
    } catch (error) {
      return {
        hasError: true,
        error: error.response
      };
    }
  };

  onUpdateUserMenuPermissions = async payload => {
    try {
      const { data } = await this.put('/users/permission', payload);
      return { data };
    } catch (error) {
      return {
        hasError: true,
        error: error.response,
        customMessage: t('GRAAS_FAIL_TO_UPDATE_USER_PERMISSIONS_GRAAS')
      };
    }
  };

  updateBusinessPassword = async payload => {
    try {
      const apiData = await this.post(`changePassword`, payload);
      if (apiData?.data?.accessToken && apiData?.data?.refreshToken) {
            Cookies.remove('accessToken');
            Cookies.remove('refreshToken');
            this.setAccessToken(apiData.data.accessToken);
            this.setRefreshToken(apiData.data.refreshToken);
          }
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error.response,
        customMessage: t('GRAAS_FAIL_TO_UPDATE_PROFILE_PASSWORD_GRAAS')
      };
    }
  };

  updateBusinessAccountSettings = async payload => {
    try {
      const apiData = await this.post(`accountSettings`, payload);
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error.response,
        customMessage: t('GRAAS_FAIL_TO_UPDATE_ACCOUNT_SETTINGS_GRAAS')
      };
    }
  };

  updateBusinessUserMessagingPreference = async payload => {
    try {
      const apiData = await this.post(`usermessagingpreference`, payload);
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error.response,
        customMessage: t('GRAAS_FAIL_TO_UPDATE_USER_MESSAGING_PREFERENCE_GRAAS')
      };
    }
  };

  getBusinessAccountSettings = async payload => {
    try {
      const apiData = await this.get(`accountSettings`, payload);
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error.response,
        customMessage: t('GRAAS_FAIL_TO_GET_ACCOUNT_SETTINGS_GRAAS')
      };
    }
  };

  getBusinessUserMessagingPreference = async payload => {
    try {
      const apiData = await this.get(`usermessagingpreference`, payload);
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error.response,
        customMessage: t('GRAAS_FAIL_TO_UPDATE_USER_MESSAGING_PREFERENCE_GRAAS')
      };
    }
  };

  getLinkedAccountDetails = async (channel) => {
    try {
      const { data } = await this.get(`linkedAccountDetails?type=${channel}`);
      return { data };
    } catch (error) {
      return {
        hasError: true,
        error: error.response
      };
    }
  };

  initiateGoogle = async (payload) => {
    try {
      const apiData = await this.post(`linkAccount/initiate/google`, payload);
      return apiData
    } catch(error) {
      return {
        hasError: true,
        error: error.response
      }
    }
  }
}
